module.exports = __webpack_public_path__ + "img/electronic_pending_zone_selected.fd1a9295.svg";